
export const mixinInOperation = {
  computed: {
    consignmentStatusId () {
      return this.consignment?.status?.id ?? this.consignment?.status_id ?? null
    },

    consignmentStatusesLine () {
      return this.consignment?.statuses_line?.statuses || []
    },

    isLastStage () {
      const lastStage = this.consignmentStatusesLine[this.consignmentStatusesLine.length - 1]
      const lastStatusId = lastStage?.status_id ?? lastStage?.status?.id

      return !!this.consignmentStatusId && !!lastStatusId && this.consignmentStatusId === lastStatusId
    },

    isStageReady () {
      const readyStage = this.consignmentStatusesLine[this.consignmentStatusesLine.length - 3]
      const readyStatusId = readyStage?.status_id ?? readyStage?.status?.id

      return !!this.consignmentStatusId && !!readyStatusId && this.consignmentStatusId === readyStatusId
    },

    isStageShipping () {
      const shippingStage = this.consignmentStatusesLine[this.consignmentStatusesLine.length - 2]
      const shippingStatusId = shippingStage?.status_id ?? shippingStage?.status?.id

      return !!this.consignmentStatusId && !!shippingStatusId && this.consignmentStatusId === shippingStatusId
    },

    isStageNoWaiting () {
      return this.isLastStage || this.isStageShipping || this.isStageReady
    },

    inOperation () {
      return !!this.consignment?.in_operation || this.isStageNoWaiting
    }
  }
}
